<template>
  <v-container class="mb-12">
      <v-layout>
          <v-flex lg8 mx-auto>
              <v-card class="pa-6 mx-auto justify-center elevation-13">
                  <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="orange--text">{{ $t('about.companyHistory') }}</p></v-card-title>
                  <v-card-text>
                      <div class="display-1 text-right">
                        <p>2017</p>
                      </div>
                      <div v-html="$t('about.history2017')" class="body-1 text-left"></div>
                      <div class="display-1 text-right">
                        <p>2018</p>
                      </div>
                      <div v-html="$t('about.history2018')" class="body-1 text-left"></div>
                  </v-card-text>
                </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AboutCompanyhistory',

  data: () => ({
  }),
};
</script>

<style scoped>
.home-hero {
    background: url('http://source.unsplash.com/0BhSKStVtdM');
    background-size: cover;
    height: 300px !important;
    padding: 0;
}
#logo {
  height: 200px;
}
</style>
